import { Navigate, useLocation } from "react-router-dom";
import { MEMBER_ELECTIONS_PENDING_PATH } from "./constants";

export default function MemberElectionsIndexPage() {
  const location = useLocation();

  return <Navigate to={`${MEMBER_ELECTIONS_PENDING_PATH}${location.search}`} replace />;
}
